import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id, name, state, regionId, enabled) {
  return yield oncallFetch("/api/oncall/partners/cities/update", {
    id,
    name,
    state,
    regionId,
    enabled,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/cities/update.js